import axios from 'axios';
import get from 'lodash/get';
import { wixAxiosInstanceConfig } from '@wix/wix-axios-config';

export const METASITE_HOST = 'https://www.wix.com';
export const METASITE_PATH = '/_api/restaurants-metasites-service/instance';

export function constructPath(msid) {
  return `${METASITE_PATH}?msid=${msid}`;
}

export default class Client {
  constructor() {
    this.instance = wixAxiosInstanceConfig(axios, { baseURL: METASITE_HOST });
  }

  getInstance(msid) {
    return this.instance.get(constructPath(msid)).then(response => get(response, 'data.instance', ''));
  }
}
